import apiFetch from '../apiFetch'

export default function (list , token) {
  return apiFetch({endPoint: `EntradaAlmacen/comprobarEliminacionEntradaAlmacenProductoSeleccion`, method: 'POST', body: list, token: token})
}